import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceTab } from './components/InvoiceTab';

import { Button, Tab, Tabs, Typography, InlineMessage, DateRangePicker, RadioButtonGroup, RadioButton, Checkbox, Dropdown, DropdownOption, Tag, Table } from "@volvo/vcdk-react";


export const InvoicePage: FunctionComponent = () => {
	

	
	/*const handleTypeaheadSelect = (selected?: Part): void => {
		let parameters: QueryParams = {
			...parts?.links.self,
			...parts?.pagination,
			page: 1,
			pageSize: 10,
		};
		if (selected) {
			parameters = {
				...parameters,
				params: { name: selected.name },
			};
		}
		getParts(parameters, true);
	};*/

	/*const handlePageChange = (event: any) => {
		if (parts !== undefined) {
			const params = createPaginationParams(parts, event.page.skip, event.page.take);
			getParts(params, true);
		}
	};*/

	/*const onAddItemToShoppingCart = (item: Part, amount: number) =>
		addPartToShoppingCart({ partId: item.id.toString(), numberOfParts: amount });*/

	return (
		<div className="page-container">

			<Typography variant="heading2">Market Company Invoice Basis</Typography>
			
			<Tabs>
				<Tab icon="several-documents" active={true}>Invoice Basis</Tab>
				<Tab icon="boxes">Archives</Tab>
			</Tabs>

			<InvoiceTab></InvoiceTab>
		</div>
	);
};
